import { Fragment, h } from "preact";
import { useNavigate } from "react-router-dom";

import Icon from "../Icon.jsx";
import Tag from "../Tag.jsx";
import Tooltip from "../Tooltip.jsx";

import i18n from "../../i18n.js";
import { displayEuro } from "../../salaryHelper.js";
import { classNames } from "../../helpers.js";
import AvatarGroup from "../AvatarGroup.jsx";

export default function ProjectItem({ linked, onShowPage, project }) {
  const navigate = useNavigate();
  let incomeRange = null;
  if (!project.incomeStart && project.incomeEnd && project.incomeEnd < 150000) {
    incomeRange = i18n.t("pages.projects.listItem.incomeNoStart", {
      value: displayEuro(project.incomeEnd),
    });
  } else if (!project.incomeEnd || project.incomeEnd >= 150000) {
    incomeRange = i18n.t("pages.projects.listItem.incomeNoEnd", {
      value: displayEuro(project.incomeStart),
    });
  } else if (
    project.incomeStart &&
    project.incomeEnd &&
    project.incomeEnd < 150000
  ) {
    incomeRange = `${displayEuro(project.incomeStart)} - ${displayEuro(
      project.incomeEnd
    )}`;
  }

  function handleClick(event) {
    event.preventDefault();

    if (linked) {
      navigate(`/projects/${project.id}`);
    }
  }

  const locations = Array.isArray(project.locations) ? project.locations : [];

  return (
    <div
      class={classNames(
        "project-item",
        linked && "project-item--linked link--invisible"
      )}
      onClick={handleClick}
    >
      <h3
        class={
          onShowPage
            ? "t-h5 t-h5--margin color-brand-jade"
            : "t-subtitle1 t-subtitle1--margin hover-black"
        }
      >
        {linked ? (
          <a class="link--invisible" href={`/projects/${project.id}`}>
            {project.jobTitle}
          </a>
        ) : (
          project.jobTitle
        )}
      </h3>

      <div class="project-item__second-row">
        <div class="project-item__second-row__left">
          <span class="project-item__second-row__item">
            <Icon>project_date</Icon>
            <span>{project.insertedAt}</span>
          </span>
          <span class="project-item__second-row__item">
            <Icon>project_company</Icon>
            <span>{project.companyName || project.worldCompanyName}</span>
          </span>
          <span class="project-item__second-row__item">
            <Icon>project_map</Icon>
            <span data-tooltip-id={`project-locations-${project.id}`}>
              {i18n.t(
                `pages.projects.listItem.location.${
                  locations.length > 1 ? "multiple" : "single"
                }`,
                {
                  count: locations.length - 1,
                  location: locations[0],
                }
              )}
            </span>
            {locations.length > 1 && (
              <Tooltip
                className="nioomi-tooltip"
                id={`project-locations-${project.id}`}
                place="bottom"
              >
                {locations.join(", ")}
              </Tooltip>
            )}
          </span>
          <span class="project-item__second-row__item">
            <Icon>project_house</Icon>
            <span>
              {i18n.t(`options.workplace_type.${project.workplaceType}`)}
            </span>
          </span>{" "}
        </div>
        <div class="project-item__second-row__right">
          {project.areaOfWork && (
            <Tag class="mb-0" grey noHover>
              {i18n.t(
                `talent_filters.area_of_work.${project.areaOfWork}.title`
              )}
            </Tag>
          )}
          <AvatarGroup users={project.talentAvatars} />
        </div>
      </div>
    </div>
  );
}
